
import Vue from "vue";
import Component from "vue-class-component";

import Card from "@/components/layout/Card.vue";

@Component<Dialog>({
  components: {
    Card
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: "50%"
    },
    padding: {
      type: Number,
      default: 4
    },
    title: {
      type: String,
      default: ""
    },
    closeable: {
      type: Boolean,
      default: true
    },
    persistent: {
      type: Boolean,
      default: true
    },
    fullWidthOnMobile: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    eager: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: ""
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    position: {
      type: String,
      default: "center"
    }
  }
})
export default class Dialog extends Vue {
  private width!: string;
  private fullWidthOnMobile!: boolean;
  private position!: "top" | "center" | "bottom";

  private emitInput(visible: boolean) {
    this.$emit("input", visible);
    if (!visible) {
      this.$emit("close");
    }
  }

  private get displayTitle() {
    return !!this.$props.title;
  }

  private get closeIcon() {
    return this.$props.closeable ? "close" : "";
  }

  private get actionIcon() {
    return this.$slots.actions ? "" : this.closeIcon;
  }

  private get dialogWidth() {
    return this.fullWidthOnMobile && this.$vuetify.breakpoint.smAndDown
      ? "80%"
      : this.width;
  }

  private get dialogContentClass() {
    return [
      "dialog-content",
      this.positionClass
    ]
      .filter(Boolean)
      .join(" ");
  }

  private get positionClass() {
    if (this.position === "top") {
      return "dialog-position-top";
    }

    if (this.position === "bottom") {
      return "dialog-position-bottom";
    }

    return "";
  }

  private get cardMaxHeight() {
    return "calc(100vh - 210px)";
  }
}
